/* @flow */
import * as React from 'react';

import { translate } from 'react-i18next';

import CentralForm from 'components/CentralForm/CentralForm.js';

import Loading from 'components/Loading/Loading';

function LoggingInP({ t }) {
  return (
    <CentralForm>
      <div>
        <h1>{t('general:accounts.logging_in')}</h1>
        <Loading />
      </div>
    </CentralForm>
  );
}

export const LoggingIn = translate()(LoggingInP);
